<template lang="pug">
  main#main.manager-accounts
    b-container(fluid)
      wc-breadcrumb(icon='fal fa-users')
      section.l-section
        .l-section-h
          router-view
</template>

<script>
import WcBreadcrumb from '@components/shared/WcBreadcrumb'

export default {
  name: 'manager-accounts',
  components: {
    WcBreadcrumb,
  },
}
</script>
